import React from 'react';

import { Action, Actions, OpenInNewIcon } from '@gogame/components';
import { ScreenLink, useScreenState } from '@gogame/screens';

import { kpiScreenLink } from 'scenes/KPI/navigation';

const KPIPresetsActions = () => {
  const screenState = useScreenState();

  return (
    <Actions>
      <Action
        label={'Open in new tab'}
        icon={<OpenInNewIcon color={'action'} />}
        component={ScreenLink}
        componentProps={{
          link: kpiScreenLink,
          params: screenState,
          target: '_blank',
        }}
      />
    </Actions>
  );
};

export default KPIPresetsActions;
